import React from 'react'

import type { SvgComponent } from '@sketch/icons'
import { ReactComponent as ScimWriteIcon } from '@sketch/icons/documents-prism-16'
import { ReactComponent as ScimReadIcon } from '@sketch/icons/workspace-16'
import { ReactComponent as ScopeDisabledIcon } from '@sketch/icons/cross-16'

import { ScimPersonalAccessTokenFragment } from '@sketch/gql-types'

import { ScopeContainer, Icon } from './AccessScope.styles'

export type ScimApiAccessScope =
  ScimPersonalAccessTokenFragment['accessScopes'][number]

export const allScopes: ScimApiAccessScope[] = ['SCIM_READ', 'SCIM_WRITE']

const scopeMetadata: {
  [key in ScimApiAccessScope]: {
    description: string
    icon: {
      src: SvgComponent
      alt: string
    }
  }
} = {
  SCIM_READ: {
    description: 'Read access to the SCIM API',
    icon: {
      src: ScimReadIcon,
      alt: 'Workspace icon',
    },
  },
  SCIM_WRITE: {
    description: 'Write access to the SCIM API ',
    icon: {
      src: ScimWriteIcon,
      alt: 'Document icon',
    },
  },
}
type AccessScopeProps = {
  scope: ScimApiAccessScope
  enabled: boolean
}

export const descriptionForScope = (scope: ScimApiAccessScope): string => {
  const { description } = scopeMetadata[scope]
  return description
}

const AccessScope: React.FC<AccessScopeProps> = props => {
  const { scope, enabled } = props
  const { description, icon } = scopeMetadata[scope]
  const iconSrc = enabled ? icon.src : ScopeDisabledIcon
  const altText = enabled ? icon.alt : 'Disabled icon'
  return (
    <ScopeContainer key={scope} enabled={enabled}>
      <Icon as={iconSrc} aria-label={altText} enabled={enabled} />
      <span>{description}</span>
    </ScopeContainer>
  )
}

export default AccessScope
